import { getSignUpAuth } from '@/config/auth';
import throwClientError from './helpers/throwClientError';
import signIn from './signIn';
export default async function resetPasswordAndSignIn(email, code, password) {
    const username = email.toLowerCase();
    try {
        await getSignUpAuth().forgotPasswordSubmit(username, code, password);
    }
    catch (error) {
        return throwClientError(error);
    }
    return signIn(username, password);
}
